import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  Wallet, Plus, Trash2, X, RefreshCw, AlertTriangle, ChevronDown, ChevronRight, Pencil,
  Upload, Check, FileText,
} from 'lucide-react';
import { useWS } from '../WSContext';

// Varlıklar — elde ne var, SATINCA ELE NE GEÇER. Kurgu backend/python/assets_db.py.
//
// İki ilke:
//   • LOT BAZLI: stopaj oranı fonun değil ALIM PARTİSİNİN özelliği (alış
//     tarihine göre değişiyor). Fon başına tek oran tutsaydık eski lotlar
//     sessizce yanlış fiyatlanırdı.
//   • BİLİNMEYEN ORAN UYDURULMAZ: 09.07.2025 öncesi alımların doğrulanmış
//     tablosu elimizde yok. Oran "bilinmiyor" basılıyor ve net'in yanına
//     "en kötü hâl" (en yüksek oranla) konuyor — eksik bilgi, net'i yukarı
//     çekip olduğundan çok para varmış gibi göstermesin.

interface Lot {
  id: number; tarih: string; adet: number; maliyet: number; birim: number;
  deger: number; kazanc: number; oran: number | null; oranElle: boolean;
  oranKaynak: string; oranNeden: string; stopaj: number | null;
  net: number; netKotu: number; ay: number; notu: string;
}
interface Varlik {
  id: number; tur: string; ad: string; kurum: string; para: string; kod: string;
  sinif: string; notu: string; lotlar: Lot[];
  adet: number; maliyet: number; deger: number; kazanc: number;
  stopaj: number; stopajKotu: number; net: number; netKotu: number;
  fiyat: number; fiyatTarih: string; fiyatTs: number; unvan: string; hata: string;
  oranYok: boolean;
  // nakit/vadeli/bloke: bakiye doğrudan saklanıyor (fiyat×adet yok)
  kisiId: number; iban: string; bakiyeTarih: string; bakiyeKaynak: string;
}
interface Kisi { id: number; ad: string; emoji: string }
interface Ozet {
  para: string; deger: number; maliyet: number; stopaj: number; net: number;
  stopajKotu: number; netKotu: number; oranYok: boolean;
}
interface Sinif { kod: string; ad: string }
interface OranSatiri {
  id: number; sinif: string; bas_tarih: string; son_tarih: string;
  oran: number; sure_ay: number; uzun_oran: number; kaynak: string;
}
interface PdfOzet {
  iban: string; para: string; bicim: string; dosya: string;
  basTarih: string; sonTarih: string; uretim: string;
  baslangic: number; giren: number; cikan: number; bakiye: number;
}
interface Eslesme {
  varlikId: number;
  varlik: { id: number; ad: string; kurum: string; para: string; bakiye: number; bakiye_tarih: string } | null;
  hesaplar: { id: number; ad: string; kurum: string; para: string; iban: string }[];
}
interface OzetKaydi {
  id: number; varlik_id: number; iban: string; para: string; bicim: string;
  bas_tarih: string; son_tarih: string; baslangic: number; giren: number;
  cikan: number; bakiye: number; uretim: string; dosya: string;
}
interface Veri {
  success: boolean; bugun: string; varliklar: Varlik[]; ozet: Ozet[];
  siniflar: Sinif[]; oranlar: OranSatiri[]; kisiler: Kisi[]; ozetler: OzetKaydi[];
}

const SIMGE: Record<string, string> = { EUR: '€', TRY: '₺', USD: '$' };
const para = (n: number, p: string) =>
  `${SIMGE[p] || ''}${(n || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const adetFmt = (n: number) =>
  (n || 0).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 6 });
const fiyatFmt = (n: number) =>
  (n || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 6 });
const yuzde = (o: number | null) => (o == null ? '—' : `%${(o * 100).toLocaleString('tr-TR', { maximumFractionDigits: 2 })}`);
const bugun = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
const yas = (ts: number) => {
  if (!ts) return '';
  const dk = Math.floor((Date.now() - ts * 1000) / 60000);
  if (dk < 60) return `${dk} dk önce`;
  const sa = Math.floor(dk / 60);
  return sa < 24 ? `${sa} sa önce` : `${Math.floor(sa / 24)} gün önce`;
};

interface Props { dark?: boolean }

export default function Assets({ dark = true }: Props) {
  const { sendWs, subscribe, connected } = useWS() as any;
  const [d, setD]     = useState<Veri | null>(null);
  const [err, setErr] = useState('');
  const [acik, setAcik] = useState<Set<number>>(new Set());
  const [yeni, setYeni] = useState(false);
  const [duzen, setDuzen] = useState<Varlik | null>(null);
  const [oranlar, setOranlar] = useState(false);
  const [yeniNakit, setYeniNakit] = useState(false);
  const [duzenNakit, setDuzenNakit] = useState<Varlik | null>(null);
  const [pdf, setPdf] = useState<{ ozet: PdfOzet; eslesme: Eslesme } | null>(null);
  const [pdfHata, setPdfHata] = useState<{ error: string; eleme: string[] } | null>(null);
  const [pdfBekle, setPdfBekle] = useState(false);
  const [gecmis, setGecmis] = useState(false);

  const t = {
    bg:    dark ? 'bg-[#030b1a]' : 'bg-[#f5f8fc]',
    text:  dark ? 'text-blue-50' : 'text-slate-800',
    card:  dark ? 'bg-[#0a1628] border-[#164a9e]' : 'bg-white border-[#d4e0f0]',
    sub:   dark ? 'bg-[#061530] border-[#0a2560]' : 'bg-[#eef3fa] border-[#d4e0f0]',
    muted: dark ? 'text-blue-300/70' : 'text-slate-500',
    inp:   dark ? 'bg-[#03112b] border-[#0a2560] text-blue-50'
                : 'bg-white border-[#d4e0f0] text-slate-800',
  };
  const alan = `px-2 py-1.5 rounded-lg border text-xs ${t.inp}`;
  const cizgi = dark ? 'border-[#0a2560]' : 'border-[#d4e0f0]';

  const yukle = useCallback(
    () => sendWs?.({ type: 'assets_list', payload: { bugun: bugun() } }), [sendWs]);
  const gonder = (type: string, payload: any) => {
    setErr('');
    sendWs?.({ type, payload: { ...payload, bugun: bugun() } });
  };

  useEffect(() => {
    const unsub = subscribe?.((m: any) => {
      if (m.type === 'assets') {
        if (m.payload?.success === false) setErr(m.payload?.error || 'okunamadı');
        else { setErr(''); setD(m.payload); }
      } else if (m.type === 'assets_ozet') {
        setPdfBekle(false);
        if (m.payload?.success) { setPdf(m.payload); setPdfHata(null); }
        else { setPdf(null); setPdfHata({ error: m.payload?.error || 'okunamadı', eleme: m.payload?.eleme || [] }); }
      } else if (m.type === 'assets_saved') {
        if (m.payload?.success === false) setErr(m.payload?.error || 'kaydedilemedi');
        else if (m.payload?.varlikId && m.payload?.guncellendi !== undefined) {
          // Özet yazıldı → onay panelini kapat.
          setPdf(null); setPdfHata(null);
          if (m.payload.guncellendi === false) {
            setErr(`Özet kaydedildi ama güncel bakiye DEĞİŞMEDİ: hesapta daha yeni bir tarih var (${m.payload.oncekiTarih}).`);
          }
        }
      }
    });
    return () => unsub?.();
  }, [subscribe]);
  useEffect(() => { if (connected) yukle(); }, [connected, yukle]);

  const sinifAd = useCallback(
    (k: string) => d?.siniflar.find(s => s.kod === k)?.ad || k || '—', [d]);

  // Dosya tarayıcıda okunup base64 ile WS'ten gidiyor: ayrı bir HTTP ucu
  // açmak, o ucu da ayrıca yetkilendirmek demekti. Hesap özeti 20-40 KB.
  const dosyaAl = useCallback((f: File) => {
    if (!f) return;
    if (!/\.pdf$/i.test(f.name)) { setPdfHata({ error: 'yalnız PDF', eleme: [] }); return; }
    if (f.size > 8 * 1024 * 1024) { setPdfHata({ error: 'dosya 8 MB üstü', eleme: [] }); return; }
    const fr = new FileReader();
    fr.onload = () => {
      const b64 = String(fr.result || '').split(',')[1] || '';
      setPdfBekle(true); setPdfHata(null); setPdf(null);
      sendWs?.({ type: 'assets_ozet_oku', payload: { b64, dosya: f.name } });
    };
    fr.readAsDataURL(f);
  }, [sendWs]);

  const fonlar = useMemo(() => (d?.varliklar || []).filter(v => v.tur === 'fon'), [d]);
  const nakitler = useMemo(
    () => (d?.varliklar || []).filter(v => v.tur !== 'fon'), [d]);
  const kisiAd = useCallback(
    (id: number) => (d?.kisiler || []).find(k => k.id === id), [d]);
  const bayat = useMemo(
    () => fonlar.some(v => v.hata || (v.fiyatTarih && v.fiyatTarih < (d?.bugun || ''))), [fonlar, d]);

  return (
    <div className={`min-h-screen ${t.bg} ${t.text} p-4 md:p-6`}>
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center gap-2 mb-4 flex-wrap">
          <button onClick={() => window.location.assign('/')}
            className={`text-xs px-2.5 py-1 rounded-lg border ${t.sub} ${t.muted} hover:text-sky-400`}>
            ← panel
          </button>
          <button onClick={() => window.location.assign('/butce')}
            className={`text-xs px-2.5 py-1 rounded-lg border ${t.sub} ${t.muted} hover:text-sky-400`}>
            bütçe
          </button>
          <button onClick={() => window.location.assign('/lptrax')}
            className={`text-xs px-2.5 py-1 rounded-lg border ${t.sub} ${t.muted} hover:text-sky-400`}>
            lp trax
          </button>
          <h1 className="text-lg font-semibold flex items-center gap-2">
            <Wallet size={17} className="text-sky-400" /> Varlıklar
          </h1>
          <div className="ml-auto flex items-center gap-2">
            <button onClick={() => gonder('assets_fiyat', {})}
              title="TEFAS fiyatlarını şimdi çek"
              className={`text-[11px] px-2.5 py-1 rounded-lg border ${bayat
                ? 'border-amber-500/45 bg-amber-500/10 text-amber-300'
                : `${t.sub} ${t.muted} hover:text-sky-400`}`}>
              <RefreshCw size={11} className="inline -mt-0.5" /> fiyatları çek
            </button>
            <button onClick={() => { setYeni(false); setDuzen(null); setDuzenNakit(null); setYeniNakit(v => !v); }}
              className={`text-[11px] px-2.5 py-1 rounded-lg border ${t.sub} ${t.muted} hover:text-sky-400`}>
              <Plus size={11} className="inline -mt-0.5" /> hesap ekle
            </button>
            <button onClick={() => { setYeniNakit(false); setDuzen(null); setYeni(v => !v); }}
              className="text-[11px] px-2.5 py-1 rounded-lg border border-sky-500/45 bg-sky-500/10 text-sky-300 hover:bg-sky-500/20">
              <Plus size={11} className="inline -mt-0.5" /> fon ekle
            </button>
          </div>
        </div>

        {err && (
          <div className="mb-3 px-3 py-2 rounded-lg border border-rose-500/40 bg-rose-500/10 text-rose-300 text-xs flex items-center gap-2">
            {err}<button onClick={() => setErr('')} className="ml-auto"><X size={13} /></button>
          </div>
        )}
        {!connected && <p className={`text-xs ${t.muted} mb-3`}>Bağlantı bekleniyor…</p>}

        {/* ── özet: değer / stopaj / ele geçecek ─────────────────────────── */}
        {!!d?.ozet.length && (
          <div className="grid gap-2.5 mb-4" style={{ gridTemplateColumns: `repeat(${Math.min(d.ozet.length, 3)}, minmax(0,1fr))` }}>
            {d.ozet.map(o => (
              <div key={o.para} className={`rounded-xl border ${t.card} p-3`}>
                <div className="flex items-baseline gap-2 mb-2">
                  <span className="font-semibold text-sm">{o.para}</span>
                  <span className={`text-[11px] ${t.muted}`}>ele geçecek</span>
                  <span className="ml-auto text-base font-semibold tabular-nums text-emerald-400"
                    title="piyasa değeri − stopaj">
                    {para(o.net, o.para)}
                  </span>
                </div>
                <div className="space-y-1 text-[11px] tabular-nums">
                  <div className="flex items-center gap-1.5">
                    <span className={t.muted}>piyasa değeri</span>
                    <span className="ml-auto">{para(o.deger, o.para)}</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <span className={t.muted}>maliyet</span>
                    <span className="ml-auto">{para(o.maliyet, o.para)}</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <span className={t.muted}>kazanç</span>
                    <span className={`ml-auto ${o.deger - o.maliyet >= 0 ? 'text-emerald-400' : 'text-rose-400'}`}>
                      {para(o.deger - o.maliyet, o.para)}
                    </span>
                  </div>
                  <div className={`flex items-center gap-1.5 pt-1 border-t ${cizgi}`}>
                    <span className={t.muted}>stopaj</span>
                    <span className="ml-auto text-rose-300">−{para(o.stopaj, o.para)}</span>
                  </div>
                  {/* Oranı bilinmeyen lot varsa net YUKARI yanlı: en kötü hâli
                      de basıyoruz ki "bu kadar param var" yanılgısı olmasın. */}
                  {o.oranYok && (
                    <div className="flex items-center gap-1.5 text-amber-400">
                      <AlertTriangle size={11} className="shrink-0" />
                      <span className="text-[10px]">oranı bilinmeyen lot var</span>
                      <span className="ml-auto" title="bilinmeyen lotlara en yüksek oran (%17,5) uygulanırsa">
                        en kötü {para(o.netKotu, o.para)}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {(yeni || duzen) && (
          <VarlikFormu t={t} alan={alan} siniflar={d?.siniflar || []} mevcut={duzen}
            kapat={() => { setYeni(false); setDuzen(null); }} gonder={gonder} />
        )}

        <OzetYukle t={t} cizgi={cizgi} dark={dark} bekle={pdfBekle} dosyaAl={dosyaAl}
          pdf={pdf} hata={pdfHata} temizle={() => { setPdf(null); setPdfHata(null); }}
          kaydet={(varlikId: number) => gonder('assets_ozet_kaydet', { ozet: pdf?.ozet, varlikId })}
          gecmis={gecmis} setGecmis={setGecmis} ozetler={d?.ozetler || []} />

        {(yeniNakit || duzenNakit) && (
          <NakitFormu t={t} alan={alan} kisiler={d?.kisiler || []} mevcut={duzenNakit}
            kapat={() => { setYeniNakit(false); setDuzenNakit(null); }} gonder={gonder} />
        )}

        {/* ── hesaplar ───────────────────────────────────────────────────── */}
        {nakitler.length > 0 && (
          <div className="mb-4">
            <div className={`flex items-center gap-1.5 px-1 pb-1.5 mb-1.5 border-b ${cizgi}`}>
              <Wallet size={13} className="text-sky-400" />
              <span className="text-xs font-semibold">Hesaplar</span>
              <span className={`text-[10px] ${t.muted}`}>
                bakiye elle ya da hesap özeti PDF'inden
              </span>
            </div>
            <div className="space-y-1.5">
              {nakitler.map(v => {
                const k = kisiAd(v.kisiId);
                // BAYAT BAKİYE sessizce taze görünmesin: 7 günden eski
                // güncelleme sarı, 30 günden eski kırmızı.
                const gun = v.bakiyeTarih
                  ? Math.round((new Date((d?.bugun || '') + 'T00:00:00').getTime()
                      - new Date(v.bakiyeTarih + 'T00:00:00').getTime()) / 86400000)
                  : null;
                const yasRenk = gun == null ? 'text-rose-400'
                  : gun > 30 ? 'text-rose-400' : gun > 7 ? 'text-amber-400' : t.muted;
                return (
                  <div key={v.id} className={`rounded-xl border ${t.card} px-3 py-2.5
                    flex items-center gap-2 text-xs flex-wrap`}>
                    <span className="text-sm shrink-0" title={k?.ad || 'sahipsiz'}>{k?.emoji || '—'}</span>
                    <span className="font-semibold">{v.ad}</span>
                    {!!v.kurum && (
                      <span className={`text-[10px] px-1.5 py-0.5 rounded border ${t.sub} ${t.muted} shrink-0`}>
                        {v.kurum}
                      </span>
                    )}
                    {!!k && <span className={`text-[10px] ${t.muted}`}>{k.ad}</span>}
                    {!!v.iban && (
                      <span className={`text-[10px] font-mono ${t.muted} hidden md:inline`}
                        title={v.iban}>…{v.iban.slice(-6)}</span>
                    )}
                    <span className={`text-[10px] ${yasRenk} shrink-0`}
                      title={v.bakiyeKaynak ? `kaynak: ${v.bakiyeKaynak}` : ''}>
                      {v.bakiyeTarih
                        ? `${v.bakiyeTarih}${gun ? ` · ${gun} gün önce` : ' · bugün'}`
                        : 'tarih yok'}
                    </span>
                    <span className="ml-auto tabular-nums font-semibold text-sky-300 shrink-0">
                      {para(v.deger, v.para)}
                    </span>
                    <button onClick={() => { setYeniNakit(false); setDuzenNakit(v); }}
                      className={`shrink-0 ${t.muted} hover:text-sky-400`} title="düzenle">
                      <Pencil size={12} />
                    </button>
                    <button
                      onClick={() => { if (window.confirm(`"${v.ad}" silinsin mi?`)) gonder('assets_delete_varlik', { id: v.id }); }}
                      className={`shrink-0 ${t.muted} hover:text-rose-400`}><Trash2 size={12} /></button>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {d && fonlar.length === 0 && !yeni && (
          <p className={`text-sm ${t.muted} py-10 text-center`}>
            Henüz fon yok. "fon ekle" ile TEFAS kodunu ve sınıfını tanımla, sonra alım lotlarını gir.
          </p>
        )}

        <div className="space-y-2">
          {fonlar.map(v => (
            <FonKarti key={v.id} v={v} t={t} alan={alan} cizgi={cizgi} sinifAd={sinifAd}
              acik={acik.has(v.id)} gonder={gonder} duzenle={() => { setYeni(false); setDuzen(v); }}
              topla={() => setAcik(s => {
                const n = new Set(s); n.has(v.id) ? n.delete(v.id) : n.add(v.id); return n;
              })} />
          ))}
        </div>

        {/* ── oran tablosu: kodda değil veride ───────────────────────────── */}
        {!!d?.oranlar.length && (
          <div className={`rounded-xl border ${t.card} p-3 mt-4`}>
            <button onClick={() => setOranlar(v => !v)}
              className="flex items-center gap-1.5 text-xs font-semibold w-full">
              {oranlar ? <ChevronDown size={13} /> : <ChevronRight size={13} />}
              Stopaj oranları
              <span className={`text-[10px] font-normal ${t.muted}`}>
                gerçek kişi · kaynak: İş Portföy, fon.org.tr, Müşavirler Kulübü
              </span>
            </button>
            {oranlar && (
              <div className="mt-2 space-y-1">
                {d.oranlar.map(o => (
                  <div key={o.id} className="flex items-baseline gap-2 text-[11px]">
                    <span className="w-44 shrink-0 truncate">{sinifAd(o.sinif)}</span>
                    <span className={`tabular-nums w-24 shrink-0 ${t.muted}`}>{o.bas_tarih}↑</span>
                    <span className="tabular-nums w-14 shrink-0 text-right">{yuzde(o.oran)}</span>
                    {o.sure_ay > 0 && (
                      <span className="text-emerald-400 shrink-0">
                        {o.sure_ay} aydan uzun → {yuzde(o.uzun_oran)}
                      </span>
                    )}
                    <span className={`ml-auto text-[10px] truncate ${t.muted}`}>{o.kaynak}</span>
                  </div>
                ))}
                <p className={`text-[10px] ${t.muted} pt-1.5 border-t ${cizgi} mt-1.5`}>
                  09.07.2025 ÖNCESİ alınan hisse-dışı lotlarda oran %15/%10/%7,5/%0 arasında
                  değişiyor ve doğrulanmış tablosu burada yok — o lotlarda oran "bilinmiyor"
                  basılır, elle girmen gerekir. Stopaj yalnız kazançtan kesilir, anaparadan değil;
                  enflasyon endekslemesi yok. Bilgi amaçlıdır, vergi danışmanlığı değildir.
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// ── fon kartı ────────────────────────────────────────────────────────────────
function FonKarti({ v, t, alan, cizgi, sinifAd, acik, topla, gonder, duzenle }: any) {
  const kazancRenk = v.kazanc >= 0 ? 'text-emerald-400' : 'text-rose-400';
  const fiyatSorun = !!v.hata || !v.fiyat;
  return (
    <div className={`rounded-xl border ${t.card}`}>
      <div className="flex items-center gap-2 text-xs px-3 py-2.5 cursor-pointer flex-wrap" onClick={topla}>
        {acik ? <ChevronDown size={13} className="shrink-0" /> : <ChevronRight size={13} className="shrink-0" />}
        <span className="font-semibold">{v.ad}</span>
        <span className={`text-[10px] px-1.5 py-0.5 rounded border ${t.sub} ${t.muted} shrink-0`}>
          {v.kod}
        </span>
        <span className={`text-[10px] px-1.5 py-0.5 rounded border border-violet-500/30 bg-violet-500/10 text-violet-300 shrink-0`}
          title="stopaj sınıfı — oran buradan türüyor">
          {sinifAd(v.sinif)}
        </span>
        {v.oranYok && (
          <span className="text-[10px] px-1.5 py-0.5 rounded border border-amber-500/35 bg-amber-500/10 text-amber-300 shrink-0"
            title="bu fonda oranı bilinmeyen lot var">
            <AlertTriangle size={9} className="inline -mt-0.5" /> oran eksik
          </span>
        )}
        <span className={`text-[10px] ${fiyatSorun ? 'text-rose-400' : t.muted} shrink-0`}
          title={v.hata || `${v.unvan} · fiyat ${v.fiyatTarih} · çekilme ${yas(v.fiyatTs)}`}>
          {fiyatSorun ? 'fiyat alınamadı' : `${fiyatFmt(v.fiyat)} · ${v.fiyatTarih}`}
        </span>

        <span className="ml-auto tabular-nums shrink-0 text-right">
          {para(v.deger, v.para)}
          <span className={`block text-[10px] leading-tight ${t.muted}`}>
            {adetFmt(v.adet)} adet
          </span>
        </span>
        <span className={`tabular-nums shrink-0 w-28 text-right ${kazancRenk}`}>
          {v.kazanc >= 0 ? '+' : ''}{para(v.kazanc, v.para)}
          <span className={`block text-[10px] leading-tight ${t.muted}`}>kazanç</span>
        </span>
        <span className="tabular-nums shrink-0 w-32 text-right">
          <span className="text-emerald-400">{para(v.net, v.para)}</span>
          <span className={`block text-[10px] leading-tight ${t.muted}`}
            title="stopaj düşülmüş — satınca ele geçecek">
            stopaj −{para(v.stopaj, v.para)}
          </span>
        </span>
      </div>

      {acik && (
        <div className={`border-t ${cizgi} px-3 py-2 space-y-1.5`}>
          {v.lotlar.length === 0 && (
            <p className={`text-[11px] ${t.muted}`}>Henüz lot yok — ilk alımını aşağıdan ekle.</p>
          )}
          {v.lotlar.map((l: Lot) => (
            <LotSatiri key={l.id} l={l} v={v} t={t} cizgi={cizgi} gonder={gonder} />
          ))}
          <LotFormu v={v} t={t} alan={alan} gonder={gonder} />
          <div className={`flex items-center gap-2 pt-1.5 border-t ${cizgi}`}>
            <button onClick={duzenle}
              className={`text-[10px] px-2 py-1 rounded-lg border ${t.sub} ${t.muted} hover:text-sky-400`}>
              <Pencil size={10} className="inline -mt-0.5" /> fonu düzenle
            </button>
            <span className={`text-[10px] ${t.muted}`}>{v.unvan}</span>
            <button
              onClick={() => { if (window.confirm(`"${v.ad}" ve ${v.lotlar.length} lotu silinsin mi?`)) gonder('assets_delete_varlik', { id: v.id }); }}
              className={`ml-auto text-[10px] px-2 py-1 rounded-lg border ${t.sub} ${t.muted} hover:text-rose-400`}>
              <Trash2 size={10} className="inline -mt-0.5" /> fonu sil
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// ── lot satırı ───────────────────────────────────────────────────────────────
// Oran burada GÖRÜNÜR ve ELLE DÜZELTİLEBİLİR: türetilmiş bir vergi oranını
// gizleseydik, yanlış olduğunda fark etmenin yolu olmazdı.
function LotSatiri({ l, v, t, cizgi, gonder }: any) {
  const [duzen, setDuzen] = useState(false);
  const [o, setO] = useState(l.oran == null ? '' : String(Math.round(l.oran * 1000) / 10));
  const yaz = () => {
    const n = (o || '').trim() === '' ? -1 : parseFloat(o.replace(',', '.'));
    gonder('assets_save_lot', {
      id: l.id, varlikId: v.id, tarih: l.tarih, adet: l.adet,
      maliyet: l.maliyet, notu: l.notu, oran: n,
    });
    setDuzen(false);
  };
  return (
    <div className={`rounded-lg border ${t.sub} px-2 py-1.5`}>
      <div className="flex items-baseline gap-2 text-[11px] tabular-nums flex-wrap">
        <span className={`font-mono w-20 shrink-0 ${t.muted}`}>{l.tarih}</span>
        <span className="w-24 shrink-0 text-right">{adetFmt(l.adet)}</span>
        <span className={`${t.muted} shrink-0`}>×{fiyatFmt(l.birim)}</span>
        <span className="w-28 shrink-0 text-right">{para(l.deger, v.para)}</span>
        <span className={`w-28 shrink-0 text-right ${l.kazanc >= 0 ? 'text-emerald-400' : 'text-rose-400'}`}>
          {l.kazanc >= 0 ? '+' : ''}{para(l.kazanc, v.para)}
        </span>
        <button onClick={() => setDuzen(x => !x)}
          title={l.oranKaynak || l.oranNeden}
          className={`shrink-0 px-1.5 py-0.5 rounded border text-[10px] ${l.oran == null
            ? 'border-amber-500/40 bg-amber-500/10 text-amber-300'
            : l.oranElle ? 'border-sky-500/40 bg-sky-500/10 text-sky-300' : `${t.sub} ${t.muted}`}`}>
          {l.oran == null ? 'oran?' : yuzde(l.oran)}{l.oranElle ? ' (elle)' : ''}
        </button>
        <span className="w-24 shrink-0 text-right text-rose-300">
          {l.stopaj == null ? '—' : `−${para(l.stopaj, v.para)}`}
        </span>
        <span className="w-28 shrink-0 text-right text-emerald-400">{para(l.net, v.para)}</span>
        <button
          onClick={() => { if (window.confirm(`${l.tarih} tarihli lot silinsin mi?`)) gonder('assets_delete_lot', { id: l.id }); }}
          className={`shrink-0 ${t.muted} hover:text-rose-400`}><Trash2 size={11} /></button>
      </div>
      {l.oran == null && !duzen && (
        <div className="text-[10px] text-amber-400/90 mt-0.5">
          {l.oranNeden} — oranı elle gir, yoksa net olduğundan yüksek görünür
          (en kötü hâl {para(l.netKotu, v.para)}).
        </div>
      )}
      {duzen && (
        <div className={`flex items-center gap-1.5 mt-1 pt-1 border-t ${cizgi} flex-wrap`}>
          <span className={`text-[10px] ${t.muted}`}>stopaj oranı %</span>
          <input value={o} onChange={e => setO(e.target.value)} placeholder="17.5" inputMode="decimal"
            onKeyDown={e => { if (e.key === 'Enter') yaz(); }}
            className={`px-1.5 py-0.5 rounded border text-[11px] w-20 tabular-nums ${t.inp}`} />
          <button onClick={yaz}
            className="text-[10px] px-2 py-0.5 rounded border border-emerald-500/45 bg-emerald-500/10 text-emerald-300">
            kaydet
          </button>
          <button onClick={() => { setO(''); gonder('assets_save_lot', { id: l.id, varlikId: v.id, tarih: l.tarih, adet: l.adet, maliyet: l.maliyet, notu: l.notu, oran: -1 }); setDuzen(false); }}
            className={`text-[10px] px-2 py-0.5 rounded border ${t.sub} ${t.muted}`}
            title="tablodan türetilen orana dön">
            tabloya dön
          </button>
          <span className={`text-[10px] ${t.muted}`}>
            {l.ay} ay tutuldu · {l.oranKaynak || l.oranNeden}
          </span>
        </div>
      )}
    </div>
  );
}

// ── lot ekleme ───────────────────────────────────────────────────────────────
// Maliyet TOPLAM olarak saklanıyor; kullanıcı birim fiyat girmeyi tercih
// ederse çarpımı burada yapıp SONUCU gösteriyoruz — kaydedilen sayı ekranda
// görünmeden gitmemeli.
function LotFormu({ v, t, alan, gonder }: any) {
  const [f, setF] = useState({ tarih: bugun(), adet: '', birim: '', toplam: '' });
  const set = (k: string, x: string) => setF(p => ({ ...p, [k]: x }));
  const sayi = (x: string) => parseFloat((x || '').replace(',', '.')) || 0;
  const adet = sayi(f.adet);
  const maliyet = sayi(f.toplam) || adet * sayi(f.birim);
  const ok = f.tarih.length === 10 && adet > 0 && maliyet > 0;
  const ekle = () => {
    if (!ok) return;
    gonder('assets_save_lot', { varlikId: v.id, tarih: f.tarih, adet, maliyet });
    setF({ tarih: bugun(), adet: '', birim: '', toplam: '' });
  };
  return (
    <div className="flex items-center gap-1.5 flex-wrap pt-1">
      <input type="date" value={f.tarih} onChange={e => set('tarih', e.target.value)}
        className={alan} title="alış tarihi — stopaj oranı buna göre" />
      <input value={f.adet} onChange={e => set('adet', e.target.value)} placeholder="adet"
        inputMode="decimal" className={`${alan} w-24 tabular-nums`} />
      <input value={f.birim} onChange={e => set('birim', e.target.value)} placeholder="birim fiyat"
        inputMode="decimal" className={`${alan} w-28 tabular-nums`} />
      <span className={`text-[10px] ${t.muted}`}>ya da</span>
      <input value={f.toplam} onChange={e => set('toplam', e.target.value)} placeholder="toplam maliyet"
        inputMode="decimal" onKeyDown={e => { if (e.key === 'Enter') ekle(); }}
        className={`${alan} w-32 tabular-nums`} />
      {maliyet > 0 && (
        <span className={`text-[10px] tabular-nums ${t.muted}`}>= {para(maliyet, v.para)}</span>
      )}
      <button onClick={ekle} disabled={!ok}
        className="px-2.5 py-1.5 rounded-lg text-[11px] border border-emerald-500/45 bg-emerald-500/10 text-emerald-300 hover:bg-emerald-500/20 disabled:opacity-40">
        <Plus size={11} className="inline -mt-0.5" /> lot ekle
      </button>
    </div>
  );
}

// ── hesap özeti yükleme ──────────────────────────────────────────────────────
// Akış: sürükle/seç → sunucu AYRIŞTIRIR AMA YAZMAZ → ekranda göster → onayla →
// yaz. Sessiz yazma en tehlikeli yol: banka şablonunu değiştirir, yanlış sayı
// yakalanır ve taze bakiye sanılır.
//
// Biçim TANIMA YOK: sunucu tüm ayrıştırıcıları deneyip MUTABAKATTAN
// (başlangıç + giren − çıkan = bakiye) geçeni alıyor. Belgenin kendi dört
// rakamı hangi ayrıştırıcının doğru olduğunu söylüyor.
function OzetYukle({ t, cizgi, dark, bekle, dosyaAl, pdf, hata, temizle, kaydet,
                     gecmis, setGecmis, ozetler }: any) {
  const [uzeri, setUzeri] = useState(false);
  const [hedef, setHedef] = useState(0);
  const es = pdf?.eslesme;
  const secili = hedef || es?.varlikId || 0;

  return (
    <div className={`rounded-xl border ${t.card} p-3 mb-4`}>
      <div className="flex items-center gap-2 mb-2 flex-wrap">
        <FileText size={13} className="text-sky-400" />
        <span className="text-xs font-semibold">Hesap özeti yükle</span>
        <span className={`text-[10px] ${t.muted}`}>
          PDF · bakiye okunur, onayından sonra yazılır
        </span>
        {!!ozetler.length && (
          <button onClick={() => setGecmis((v: boolean) => !v)}
            className={`ml-auto text-[10px] px-2 py-1 rounded-lg border ${t.sub} ${t.muted} hover:text-sky-400`}>
            {gecmis ? 'gizle' : `geçmiş (${ozetler.length})`}
          </button>
        )}
      </div>

      {!pdf && (
        <label
          onDragOver={e => { e.preventDefault(); setUzeri(true); }}
          onDragLeave={() => setUzeri(false)}
          onDrop={e => { e.preventDefault(); setUzeri(false); dosyaAl(e.dataTransfer.files?.[0]); }}
          className={`flex items-center justify-center gap-2 py-5 rounded-lg border border-dashed cursor-pointer
            text-xs transition ${uzeri ? 'border-sky-500 bg-sky-500/10 text-sky-300' : `${cizgi} ${t.muted}`}`}>
          <input type="file" accept="application/pdf,.pdf" className="hidden"
            onChange={e => { const f = e.target.files?.[0]; if (f) dosyaAl(f); e.target.value = ''; }} />
          {bekle ? <><RefreshCw size={13} className="animate-spin" /> okunuyor…</>
                 : <><Upload size={13} /> PDF'i buraya sürükle ya da seç</>}
        </label>
      )}

      {hata && (
        <div className="mt-2 px-3 py-2 rounded-lg border border-rose-500/40 bg-rose-500/10 text-rose-300 text-xs">
          <div className="flex items-center gap-2">
            <AlertTriangle size={13} className="shrink-0" /> {hata.error}
            <button onClick={temizle} className="ml-auto"><X size={13} /></button>
          </div>
          {/* Neden elendiğini saklamıyoruz: yeni bir biçim eklemek
              gerektiğinde ilk bakılacak yer burası. */}
          {!!hata.eleme?.length && (
            <ul className={`mt-1 text-[10px] ${t.muted} list-disc pl-4`}>
              {hata.eleme.map((e: string, i: number) => <li key={i}>{e}</li>)}
            </ul>
          )}
        </div>
      )}

      {pdf && (
        <div className={`mt-1 rounded-lg border ${t.sub} p-2.5`}>
          <div className="flex items-center gap-2 mb-1.5 flex-wrap text-xs">
            <Check size={13} className="text-emerald-400" />
            <span className="font-semibold">Okundu</span>
            <span className={`text-[10px] px-1.5 py-0.5 rounded border ${t.sub} ${t.muted}`}>
              {pdf.ozet.bicim}
            </span>
            <span className={`text-[10px] font-mono ${t.muted}`}>{pdf.ozet.iban}</span>
            <span className={`text-[10px] ${t.muted}`}>
              {pdf.ozet.basTarih} → {pdf.ozet.sonTarih}
            </span>
            <button onClick={temizle} className={`ml-auto ${t.muted} hover:text-rose-400`}>
              <X size={13} />
            </button>
          </div>

          <div className="flex items-baseline gap-3 flex-wrap text-[11px] tabular-nums mb-2">
            <span className={t.muted}>başlangıç {para(pdf.ozet.baslangic, pdf.ozet.para)}</span>
            <span className="text-emerald-400">+{para(pdf.ozet.giren, pdf.ozet.para)}</span>
            <span className="text-rose-400">−{para(pdf.ozet.cikan, pdf.ozet.para)}</span>
            <span className={t.muted}>=</span>
            <span className="text-sm font-semibold text-sky-300">
              {para(pdf.ozet.bakiye, pdf.ozet.para)}
            </span>
            <span className="text-[10px] text-emerald-400"
              title="başlangıç + giren − çıkan = bakiye · bu tutmadan hiçbir şey yazılmıyor">
              ✓ mutabık
            </span>
          </div>

          <div className="flex items-center gap-2 flex-wrap">
            <span className={`text-[10px] ${t.muted}`}>hesap</span>
            <select value={secili} onChange={e => setHedef(Number(e.target.value))}
              className={`px-2 py-1.5 rounded-lg border text-xs ${t.inp}`}>
              <option value={0}>— seç —</option>
              {es?.hesaplar.map((h: any) => (
                <option key={h.id} value={h.id}>
                  {h.ad}{h.kurum ? ` · ${h.kurum}` : ''}{h.iban ? ` · …${h.iban.slice(-6)}` : ''}
                </option>
              ))}
            </select>
            {es?.varlikId ? (
              <span className="text-[10px] text-emerald-400">IBAN eşleşti</span>
            ) : (
              <span className="text-[10px] text-amber-400">
                <AlertTriangle size={10} className="inline -mt-0.5" /> IBAN hiçbir hesapla
                eşleşmedi — hangisine yazılacağını seç
              </span>
            )}
            <button disabled={!secili} onClick={() => kaydet(secili)}
              className="ml-auto px-3 py-1.5 rounded-lg text-xs font-semibold bg-emerald-600/25 border border-emerald-500/50 text-emerald-300 hover:bg-emerald-600/40 disabled:opacity-40">
              bakiyeyi yaz
            </button>
          </div>
        </div>
      )}

      {gecmis && !!ozetler.length && (
        <div className={`mt-2 pt-2 border-t ${cizgi} space-y-1`}>
          {ozetler.map((o: OzetKaydi) => (
            <div key={o.id} className="flex items-baseline gap-2 text-[11px] tabular-nums">
              <span className={`font-mono w-24 shrink-0 ${t.muted}`}>{o.son_tarih}</span>
              <span className={`text-[10px] shrink-0 ${t.muted}`}>{o.bicim}</span>
              <span className={`font-mono text-[10px] shrink-0 ${t.muted}`}>…{o.iban.slice(-6)}</span>
              <span className={`${t.muted} truncate`}>{o.bas_tarih} → {o.son_tarih}</span>
              <span className="ml-auto shrink-0 text-sky-300">{para(o.bakiye, o.para)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── hesap tanımı (nakit / vadeli / bloke) ────────────────────────────────────
// Bakiye ve TARİHİ birlikte giriliyor: tarihsiz bir bakiye, ne zamanki bakiye
// olduğu bilinmeden toplama girer ve bayatladığını kimse fark etmez.
function NakitFormu({ t, alan, kisiler, mevcut, kapat, gonder }: any) {
  const [f, setF] = useState<any>(mevcut
    ? { id: mevcut.id, tur: mevcut.tur, ad: mevcut.ad, kurum: mevcut.kurum,
        para: mevcut.para, kisiId: String(mevcut.kisiId || 0), iban: mevcut.iban,
        bakiye: String(mevcut.deger ?? ''), bakiyeTarih: mevcut.bakiyeTarih || bugun(),
        notu: mevcut.notu }
    : { id: 0, tur: 'nakit', ad: '', kurum: '', para: 'EUR', kisiId: String(kisiler[0]?.id || 0),
        iban: '', bakiye: '', bakiyeTarih: bugun(), notu: '' });
  const set = (k: string, v: any) => setF((p: any) => ({ ...p, [k]: v }));
  const ok = f.ad.trim() && f.bakiyeTarih.length === 10;
  return (
    <div className={`rounded-xl border ${t.card} p-3 mb-4`}>
      <div className={`text-[11px] ${t.muted} mb-2`}>
        {mevcut ? 'Hesabı düzenle' : 'Yeni hesap'} — bakiye bütçenin para birimi kartında toplanır
      </div>
      <div className="flex items-center gap-1.5 flex-wrap">
        <select value={f.tur} onChange={e => set('tur', e.target.value)} className={alan}>
          <option value="nakit">vadesiz / kart</option>
          <option value="vadeli">vadeli hesap</option>
          <option value="bloke">bloke hesap</option>
        </select>
        <input value={f.ad} onChange={e => set('ad', e.target.value)} placeholder="ad (N26)"
          className={`${alan} w-44`} />
        <input value={f.kurum} onChange={e => set('kurum', e.target.value)} placeholder="kurum"
          className={`${alan} w-36`} />
        <select value={f.kisiId} onChange={e => set('kisiId', e.target.value)} className={alan}
          title="hesap kimin">
          <option value="0">— kişi yok —</option>
          {kisiler.map((k: Kisi) => <option key={k.id} value={k.id}>{k.emoji} {k.ad}</option>)}
        </select>
        <select value={f.para} onChange={e => set('para', e.target.value)} className={alan}>
          {['EUR', 'TRY', 'USD'].map(p => <option key={p} value={p}>{p}</option>)}
        </select>
        <input value={f.iban} onChange={e => set('iban', e.target.value.toUpperCase())}
          placeholder="IBAN (isteğe bağlı)" className={`${alan} w-52 font-mono`}
          title="PDF özet yüklenince hesabı bununla eşleyeceğim" />
        <input value={f.bakiye} onChange={e => set('bakiye', e.target.value)} placeholder="bakiye"
          inputMode="decimal" className={`${alan} w-28 tabular-nums`} />
        <input type="date" value={f.bakiyeTarih} onChange={e => set('bakiyeTarih', e.target.value)}
          className={alan} title="bakiye hangi tarihe ait" />
        <button disabled={!ok}
          onClick={() => {
            gonder('assets_save_varlik', {
              ...f, kisiId: parseInt(f.kisiId, 10) || 0,
              bakiye: parseFloat((f.bakiye || '0').replace(',', '.')) || 0,
              bakiyeKaynak: 'elle',
            });
            kapat();
          }}
          className="px-3 py-1.5 rounded-lg text-xs font-semibold bg-sky-600/25 border border-sky-500/50 text-sky-300 hover:bg-sky-600/40 disabled:opacity-40">
          {mevcut ? 'Güncelle' : 'Ekle'}
        </button>
        <button onClick={kapat} className={`px-2.5 py-1.5 rounded-lg text-[11px] border ${t.sub} ${t.muted}`}>
          vazgeç
        </button>
      </div>
    </div>
  );
}

// ── fon tanımı ───────────────────────────────────────────────────────────────
function VarlikFormu({ t, alan, siniflar, mevcut, kapat, gonder }: any) {
  const [f, setF] = useState<any>(mevcut
    ? { id: mevcut.id, ad: mevcut.ad, kod: mevcut.kod, kurum: mevcut.kurum,
        para: mevcut.para, sinif: mevcut.sinif, notu: mevcut.notu }
    : { id: 0, ad: '', kod: '', kurum: 'İş Bankası', para: 'TRY', sinif: 'ppf', notu: '' });
  const set = (k: string, v: any) => setF((p: any) => ({ ...p, [k]: v }));
  const ok = f.ad.trim() && f.kod.trim() && f.sinif;
  return (
    <div className={`rounded-xl border ${t.card} p-3 mb-4`}>
      <div className={`text-[11px] ${t.muted} mb-2`}>
        {mevcut ? 'Fonu düzenle' : 'Yeni fon'} — TEFAS kodu fiyatı çeker, sınıf stopaj oranını belirler
      </div>
      <div className="flex items-center gap-1.5 flex-wrap">
        <input value={f.ad} onChange={e => set('ad', e.target.value)} placeholder="ad (İş Para Piyasası)"
          className={`${alan} w-52`} />
        <input value={f.kod} onChange={e => set('kod', e.target.value.toUpperCase())}
          placeholder="TEFAS kodu" className={`${alan} w-28 font-mono`} />
        <input value={f.kurum} onChange={e => set('kurum', e.target.value)} placeholder="kurum"
          className={`${alan} w-36`} />
        <select value={f.para} onChange={e => set('para', e.target.value)} className={alan}>
          {['TRY', 'EUR', 'USD'].map(p => <option key={p} value={p}>{p}</option>)}
        </select>
        <select value={f.sinif} onChange={e => set('sinif', e.target.value)} className={alan}
          title="stopaj sınıfı">
          {siniflar.map((s: Sinif) => <option key={s.kod} value={s.kod}>{s.ad}</option>)}
        </select>
        <button disabled={!ok}
          onClick={() => { gonder('assets_save_varlik', { ...f, tur: 'fon' }); kapat(); }}
          className="px-3 py-1.5 rounded-lg text-xs font-semibold bg-sky-600/25 border border-sky-500/50 text-sky-300 hover:bg-sky-600/40 disabled:opacity-40">
          {mevcut ? 'Güncelle' : 'Ekle'}
        </button>
        <button onClick={kapat} className={`px-2.5 py-1.5 rounded-lg text-[11px] border ${t.sub} ${t.muted}`}>
          vazgeç
        </button>
      </div>
    </div>
  );
}
